import React from 'react'
import { usePostRequest } from '../hooks/request'
import { RESULT_ITEM_LIST } from '../urls'
import ResultItemForm from './ResultItemForm'

export default function ResultItemCreate({ onCancel, onSuccess, finance, rotationId }) {
    const monthCreate = usePostRequest({ url: RESULT_ITEM_LIST.replace('{resultId}', finance.id) })

    async function onSubmit(data) {
        const { success } = await monthCreate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <b>Добавить</b><br /><br />
            <ResultItemForm
                finance={finance}
                rotationId={rotationId}
                onSubmit={onSubmit}
                onCancel={onCancel}
                loading={monthCreate.loading} />
        </div>
    )
}
